




































































import { Component, Vue } from "vue-property-decorator";
import AdminsApi from "@/services/AdminsApi";
import UsersApi from "@/services/UsersApi";
import organizationAdminsApi from "@/services/OrganizationAdmins";
import OrganizationUsersApi from "@/services/OrganizationUsers";
import TooltipModule from "@/store/tooltip";
import CTooltip from "@/components/CTooltip.vue";
import AuthModule from "@/store/auth";
import logger from "@/lib/log/logger";

@Component({
  components: {
    CTooltip,
  },
})
export default class FormPassEdit extends Vue {
  private password = "";

  // cfmの宣言
  private cfm = "";

  // uuidの宣言
  private uuid = "";

  // エラーモーダルの表示
  private get isTooltipShow() {
    return TooltipModule.isShow;
  }

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  // 送信が押されたときadminPassまたはuserPassを実行
  private async submit() {
    if (!this.me) {
      return;
    }
    if (this.cfm !== this.password) {
      return;
    }
    try {
      if (this.$route.name === "MRegisterPassEdit") {
        await this.adminPass(this.me.uuid, this.password);
      } else if (this.$route.name === "URegisterPassEdit") {
        if (this.me.roleId === 2) {
          await this.userPass(this.me.uuid, this.password);
        } else {
          await this.organizationUserPass(this.me.uuid, this.password);
        }
      } else {
        await this.organizationAdminPass(this.me.uuid, this.password);
      }
    } catch (err) {
      TooltipModule.commitIsShow(true);
      setTimeout(() => {
        TooltipModule.commitIsShow(false);
      }, 5000);
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
  }

  private async userPass(uuid: string, password: string) {
    await UsersApi.instance.updateUserByUuid(uuid, { password });
    // URegisterPassEditCompに進む
    this.$router.push({ name: "URegisterPassEditComp" });
  }

  private async adminPass(uuid: string, password: string) {
    await AdminsApi.instance.updateAdminByUuid(uuid, { password });
    // MRegisterPassEditCompに進む
    this.$router.push({ name: "MRegisterPassEditComp" });
  }

  private async organizationUserPass(uuid: string, password: string) {
    await OrganizationUsersApi.instance.updateOrganizationUserByUuid(uuid, { password });
    // URegisterPassEditCompに進む
    this.$router.push({ name: "URegisterPassEditComp" });
  }

  private async organizationAdminPass(uuid: string, password: string) {
    await organizationAdminsApi.instance.updateOrganizationAdminByUuid(uuid, { password });
    // ORegisterPassEditCompに進む
    this.$router.push({ name: "ORegisterPassEditComp" });
  }
}
